var _path, _path2, _path3, _path4, _path5, _rect, _g, _path6, _path7, _path8, _path9, _path10, _rect2, _g2, _path11, _path12, _path13, _path14, _path15, _rect3, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEThereUm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 134,
    viewBox: "0 0 221 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.249 74.0781L174.404 104.04L118.249 134.001L62.0938 104.04L118.249 74.0781Z",
    fill: "#801212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M174.403 40.9615L118.248 11V74.0769L174.403 104.038V40.9615Z",
    fill: "#801212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.249 11L62.0938 40.9615V104.038L118.249 74.0769V11Z",
    fill: "#801212"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.748 133.166V71.2224L173.903 41.7944V103.738L118.748 133.166Z",
    fill: "url(#paint0_linear_38_6631)",
    stroke: "url(#paint1_linear_38_6631)",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5938 103.738V41.7944L117.749 71.2224V133.166L62.5938 103.738Z",
    fill: "url(#paint2_linear_38_6631)",
    stroke: "url(#paint3_linear_38_6631)",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.470738,
    width: 62.648,
    height: 62.648,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 118.663 11.2491)",
    fill: "url(#paint4_linear_38_6631)",
    stroke: "url(#paint5_linear_38_6631)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_38_6631)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.648,
    height: 63.648,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 118.248 11)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.470738,
    width: 62.648,
    height: 62.648,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 118.663 11.2491)",
    stroke: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5016 100.385L74.0033 117.192L42.5016 134L11 117.192L42.5016 100.385Z",
    fill: "#801212"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0036 81.8077L42.502 65V100.385L74.0036 117.192V81.8077Z",
    fill: "#801212"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5016 65L11 81.8077V117.192L42.5016 100.385V65Z",
    fill: "#801212"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.002 133.168V98.9163L73.5036 82.6421V116.893L43.002 133.168Z",
    fill: "url(#paint6_linear_38_6631)",
    stroke: "url(#paint7_linear_38_6631)",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 116.893V82.6421L42.0016 98.9163V133.168L11.5 116.893Z",
    fill: "url(#paint8_linear_38_6631)",
    stroke: "url(#paint9_linear_38_6631)",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.470738,
    width: 34.7051,
    height: 34.7051,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 42.9173 65.2491)",
    fill: "url(#paint10_linear_38_6631)",
    stroke: "url(#paint11_linear_38_6631)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_38_6631)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.7051,
    height: 35.7051,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 42.502 65)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.470738,
    width: 34.7051,
    height: 34.7051,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 42.9173 65.2491)",
    stroke: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M185.572 108.18L209.769 121.09L185.572 134L161.375 121.09L185.572 108.18Z",
    fill: "#801212"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M209.769 93.9103L185.572 81V108.18L209.769 121.09V93.9103Z",
    fill: "#801212"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M185.572 81L161.375 93.9103V121.09L185.572 108.18V81Z",
    fill: "#801212"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M186.072 133.167V107.12L209.269 94.7436V120.79L186.072 133.167Z",
    fill: "url(#paint12_linear_38_6631)",
    stroke: "url(#paint13_linear_38_6631)",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M161.875 120.79V94.7436L185.072 107.12V133.167L161.875 120.79Z",
    fill: "url(#paint14_linear_38_6631)",
    stroke: "url(#paint15_linear_38_6631)",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.470738,
    width: 26.4257,
    height: 26.4257,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 185.988 81.2491)",
    fill: "url(#paint16_linear_38_6631)",
    stroke: "url(#paint17_linear_38_6631)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_38_6631)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.4257,
    height: 27.4257,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 185.572 81)",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.470738,
    width: 26.4257,
    height: 26.4257,
    transform: "matrix(0.882273 0.470738 -0.882273 0.470738 185.988 81.2491)",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_38_6631",
    x: 51.6938,
    y: 0.6,
    width: 133.109,
    height: 80.7238,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.2,
    result: "effect1_foregroundBlur_38_6631"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_38_6631",
    x: 0.6,
    y: 54.6,
    width: 83.8039,
    height: 54.4152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.2,
    result: "effect1_foregroundBlur_38_6631"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_38_6631",
    x: 150.975,
    y: 70.6,
    width: 69.1945,
    height: 46.6203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.2,
    result: "effect1_foregroundBlur_38_6631"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_6631",
    x1: 215.75,
    y1: -8.50097,
    x2: 55.4054,
    y2: 167.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80DE55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45782E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_38_6631",
    x1: 114.067,
    y1: 127.072,
    x2: 178.792,
    y2: 61.9928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71C749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0FF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_38_6631",
    x1: 57.9128,
    y1: 127.072,
    x2: 122.637,
    y2: 61.9928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71C749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0FF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_38_6631",
    x1: 57.9128,
    y1: 127.072,
    x2: 122.637,
    y2: 61.9928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71C749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0FF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_38_6631",
    x1: -12.7491,
    y1: 59.4842,
    x2: 40.9261,
    y2: 2.66797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.121443,
    stopColor: "#71C749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#C8FFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9AF770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910216,
    stopColor: "#A0EB7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_38_6631",
    x1: -4.73887,
    y1: 58.9091,
    x2: 34.3394,
    y2: -6.19133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71C749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0FF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_38_6631",
    x1: 97.1982,
    y1: 54.0616,
    x2: 7.24869,
    y2: 152.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80DE55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45782E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_38_6631",
    x1: 40.1565,
    y1: 130.115,
    x2: 76.4656,
    y2: 93.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71C749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0FF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_38_6631",
    x1: 8.65457,
    y1: 130.115,
    x2: 44.9636,
    y2: 93.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71C749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0FF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_38_6631",
    x1: 8.65457,
    y1: 130.115,
    x2: 44.9636,
    y2: 93.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71C749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0FF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_38_6631",
    x1: -7.15196,
    y1: 33.3693,
    x2: 22.9586,
    y2: 1.49667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.121443,
    stopColor: "#71C749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#C8FFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9AF770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910216,
    stopColor: "#A0EB7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_38_6631",
    x1: -2.6584,
    y1: 33.0467,
    x2: 19.2636,
    y2: -3.47319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71C749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0FF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_38_6631",
    x1: 227.585,
    y1: 72.5972,
    x2: 158.494,
    y2: 148.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80DE55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45782E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_38_6631",
    x1: 183.771,
    y1: 131.015,
    x2: 211.66,
    y2: 102.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71C749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0FF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_38_6631",
    x1: 159.573,
    y1: 131.015,
    x2: 187.463,
    y2: 102.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71C749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0FF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_38_6631",
    x1: 159.573,
    y1: 131.015,
    x2: 187.463,
    y2: 102.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71C749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0FF8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_38_6631",
    x1: -5.49355,
    y1: 25.6315,
    x2: 17.6349,
    y2: 1.14962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.121443,
    stopColor: "#71C749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#C8FFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9AF770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910216,
    stopColor: "#A0EB7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_38_6631",
    x1: -2.04196,
    y1: 25.3837,
    x2: 14.7967,
    y2: -2.66782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71C749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0FF8C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEThereUm);
export default __webpack_public_path__ + "static/media/e-there-um.3e97fe4159f9bc828c06d6d0c015f413.svg";
export { ForwardRef as ReactComponent };